<template>
  <div>
    <div class="d-flex justify-center align-center" @click="achievementDialog = true" style="cursor: pointer">
      <v-progress-circular
        :rotate="-90"
        :size="60"
        :width="10"
        :value="(xp.currentXp / xp.nextXpThreshold) * 100"
        color="orange"
        class="mr-4"
        style="background-color: white; border-radius: 30px; overflow: hidden"
      >
        <div class="black--text">
          <div style="font-size: 8px" class="mt-1">{{ $t("string.avatarLevel") }}</div>
          <div class="text-center"><b>{{ xp.currentLevel }}</b></div>
        </div>
      </v-progress-circular>
    </div>

    <ApiErrorDialog v-if="api.isError" :api="api" />
    <AchievementDialog
        v-if="achievementDialog"
        :callbackClose="() => (achievementDialog = false)"
        :showDialog="true"
      />
  </div>
</template>
    
<script>
import { mapState } from "vuex";
export default {
  components: {
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
      AchievementDialog: () =>
      import(
        /* webpackChunkName: "component-tutorial-dialog" */ "@/components/AchievementDialog.vue"
      ),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
  }),
  props: [
    //
  ],
  data: () => ({
    achievementDialog: false,
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    xp: {
      currentLevel: 0,
      currentXp: 0,
      nextLevel: 0,
      nextXpThreshold: 1,
    },
  }),
  created() {
    //
  },
  async mounted() {
    await this.loadXP();
  },
  methods: {
    async loadXP() {
      this.api.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/xp/load";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
        console.error(e);
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.xp = resp;
      };
      await this.$api.fetch(this.api);
    },
  },
};
</script>